module.exports = __webpack_public_path__ + "static/media/3.ee12a313.jpg";